import { devInstance } from '../axios/axiosInstance'


export const fetchCurrency = async (payload: any) => {
    const response = await devInstance.post('/Currency/Search', payload)
    return response
}
